/* Recheck Shopify product data before any cart navigation. No discount is auto-applied. */
(() => {
  const warrantyObserver = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      target.classList.toggle('is-in-view', isIntersecting);
      if (isIntersecting) target.classList.add('is-revealed');
    });
  }, {threshold: .3});
  document.querySelectorAll('.kura-warranty-motion').forEach(badge => warrantyObserver.observe(badge));
  const firstPurchaseBlock = document.querySelector('.kura-purchase-design');
  if (firstPurchaseBlock) {
    const updateStickyCTA = () => document.documentElement.classList.toggle(
      'past-first-purchase', firstPurchaseBlock.getBoundingClientRect().bottom <= 0
    );
    const stickyObserver = new IntersectionObserver(updateStickyCTA, {threshold: 0});
    stickyObserver.observe(firstPurchaseBlock);
    let stickyFrame = 0;
    window.addEventListener('scroll', () => {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(() => {stickyFrame = 0; updateStickyCTA();});
    }, {passive: true});
    window.addEventListener('resize', updateStickyCTA);
    window.addEventListener('pageshow', updateStickyCTA);
    updateStickyCTA();
  }
  const drawer = document.querySelector('#purchase-configurator');
  if (!drawer) return;
  const submit = drawer.querySelector('[data-purchase-submit]');
  const status = drawer.querySelector('[data-purchase-status]');
  const handles = {
    '5kg': '真空保存容器-空蔵-kura-5kg',
    '7.5kg': '真空保存容器-空蔵-kura-7-5kg',
    '10kg': '真空保存容器-空蔵-kura-7-5kg-コピー'
  };
  let catalog = {}, busy = false;
  const selection = () => ({
    size: drawer.querySelector('[data-purchase-size].is-selected')?.dataset.purchaseSize,
    color: drawer.querySelector('[data-purchase-color].is-selected')?.dataset.purchaseColor
  });
  const selected = () => { const s = selection(); return catalog[s.size]?.variants.find(v => v.title === s.color); };
  function render() {
    const v = selected();
    const fallback = drawer.querySelector('.purchase-drawer__fallback');
    if (fallback) fallback.hidden = !!v?.available;
    submit.disabled = busy || !v?.available;
    submit.textContent = busy ? '在庫を確認しています' : v?.available ? 'カートに入れる' : '現在購入できません';
    if (v) drawer.querySelector('[data-purchase-price]').textContent = '¥' + new Intl.NumberFormat('ja-JP').format(v.price / 100);
    status.textContent = v ? (v.available ? '' : '選択した商品は現在在庫がありません。') : '商品情報を確認できません。商品一覧からご確認ください。';
  }
  async function refresh() {
    const values = await Promise.all(Object.entries(handles).map(async ([size, handle]) => {
      const path = '/products/' + encodeURIComponent(handle) + '.js';
      const local = ['localhost', '127.0.0.1'].includes(location.hostname);
      const response = await fetch(local ? '/store-data' + path : path, {cache: 'no-store', signal: AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('Product data unavailable');
      return [size, await response.json()];
    }));
    catalog = Object.fromEntries(values);
  }
  // The size guide changes selection without clicking a size button.
  document.addEventListener('close', e => {
    if (e.target instanceof HTMLDialogElement && e.target.id === 'size-guide') render();
  }, true);
  drawer.addEventListener('click', e => {
    if (e.target.closest('[data-purchase-size], [data-purchase-color]')) queueMicrotask(render);
  });
  submit.addEventListener('click', async e => {
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return;
    const expected = selection(); busy = true; render();
    try {
      await refresh();
      const now = selection(), v = selected();
      if (now.size !== expected.size || now.color !== expected.color) return;
      if (v?.available) location.assign('https://everyu-official.com/cart/' + v.id + ':1?storefront=true');
    } catch { catalog = {}; }
    finally { busy = false; render(); }
  }, true);
  busy = true; render();
  window.addEventListener('pageshow', render);
  refresh().catch(() => { catalog = {}; }).finally(() => {busy = false; render();});
})();
